import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ActionButton, AltButton } from '../../../../common/Buttons/Buttons';
import { notify } from '../../../../../assets/helpers/toast';
import { currencyFormat } from '../../../../../assets/helpers/funciones';
import './CasheaLinkFlow.scss';

const DisabledField = ({ label, value, bootstrap }) => (
  <div className={`input-component-container ${bootstrap}`}>
    <label>{label}</label>
    <div>
      <input type="text" value={value ?? ''} disabled readOnly />
    </div>
  </div>
);

export const CasheaLinkFlow = ({
  planName,
  priceUSD,
  priceBs,
  membershipId,
  onQueryPlan,
  onConfirmOrder,
  onCancel,
  hideNewAffiliation,
  hideSummaryFields,
}) => {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [identification, setIdentification] = useState('');
  const [initial, setInitial] = useState(null);
  const [orderResult, setOrderResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const financedAmount = initial != null ? priceUSD - initial : null;

  const handleIdentificationChange = (e) => {
    setIdentification(e.target.value.replace(/\D/g, ''));
  };

  const handleQuery = async () => {
    setLoading(true);
    const result = await onQueryPlan(identification);
    setLoading(false);
    if (result?.ok) {
      setInitial(result.initial);
      setStep(2);
    }
  };

  const handleConfirmOrder = async () => {
    setLoading(true);
    const result = await onConfirmOrder(identification, initial);
    setLoading(false);
    if (result?.ok) {
      setOrderResult(result.data);
      setStep(3);
    }
  };

  const handleCopyLink = () => {
    const link = orderResult?.casheaLink || orderResult?.paymentLink || orderResult?.link;
    if (!link) {
      return;
    }
    navigator.clipboard.writeText(link);
    notify('Link copiado', 'success');
  };

  const handleNewAffiliation = () => {
    window.location.reload();
  };

  const link =
    orderResult?.casheaLink || orderResult?.paymentLink || orderResult?.link;

  return (
    <div className="cashea-link-flow row">
      {!hideSummaryFields && (
        <>
          <DisabledField bootstrap={'col-12 col-md-6'} label={'Plan'} value={planName} />
          <DisabledField
            bootstrap={'col-12 col-md-6'}
            label={'Precio USD'}
            value={priceUSD}
          />
          <DisabledField bootstrap={'col-12 col-md-6'} label={'Precio Bs'} value={priceBs} />
          <DisabledField
            bootstrap={'col-12 col-md-6'}
            label={'Tipo de pago'}
            value={'Cashea Link'}
          />
        </>
      )}

      {step === 1 && (
        <>
          <hr className="w-100" />
          <div className="input-component-container col-12 col-md-6">
            <label>Cédula del titular Cashea *</label>
            <div>
              <input
                type="text"
                inputMode="numeric"
                placeholder="Ej.: 13289947"
                value={identification}
                onChange={handleIdentificationChange}
              />
            </div>
            <small className="text-muted">Solo números, sin símbolos ni espacios.</small>
          </div>
          <div className="cashea-link-buttons-container col-12">
            <AltButton label={'Volver'} action={onCancel} />
            <ActionButton
              label={loading ? 'Consultando...' : 'Consultar'}
              action={handleQuery}
              disabled={loading || !identification}
            />
          </div>
        </>
      )}

      {step === 2 && (
        <>
          <hr className="w-100" />
          <div className="col-12">
            <p>Cédula consultada: {identification}</p>
          </div>
          <div className="col-12 cashea-link-cards-row">
            <div className="cashea-link-card">
              <p className="cashea-link-card-label">Monto total</p>
              <h5>{currencyFormat(priceUSD)}</h5>
            </div>
            <div className="cashea-link-card">
              <p className="cashea-link-card-label">Cuota inicial</p>
              <h5 className="cashea-link-highlight">{currencyFormat(initial)}</h5>
            </div>
            <div className="cashea-link-card">
              <p className="cashea-link-card-label">Monto financiado</p>
              <h5>{currencyFormat(financedAmount)}</h5>
            </div>
          </div>
          <div className="cashea-link-banner col-12">
            <p>El cliente recibirá un link para completar el pago desde su app Cashea.</p>
            <p>La orden se creará con estado Incompleto hasta que el pago sea procesado.</p>
            <p>Si no paga en 48 h, Cashea expira la orden automáticamente.</p>
          </div>
          <div className="cashea-link-buttons-container col-12">
            <AltButton label={'Volver'} action={() => setStep(1)} />
            <ActionButton
              label={loading ? 'Confirmando...' : 'Confirmar orden'}
              action={handleConfirmOrder}
              disabled={loading}
            />
          </div>
        </>
      )}

      {step === 3 && (
        <div className="col-12 cashea-link-success">
          <h5>¡Orden creada!</h5>
          <p>
            Registramos la afiliación por {currencyFormat(priceUSD)}. Comparte el link con tu
            comprador.
          </p>
          <div className="cashea-link-status-badge">
            Estado: Incompleto — esperando pago del cliente
          </div>

          {link && (
            <div className="cashea-link-copy-row">
              <div className="input-component-container">
                <div>
                  <input type="text" readOnly value={link} />
                </div>
              </div>
              <ActionButton label={'Copiar link'} action={handleCopyLink} />
            </div>
          )}

          <div className="cashea-link-warning">
            <p>Recuerda: esta orden expira en 48 horas.</p>
            <p>Cashea elimina automáticamente las órdenes sin pago.</p>
          </div>

          <div className="cashea-link-buttons-container">
            <AltButton
              label={'Consultar detalle'}
              action={() => history.push(`/afiliations/edit-order/${membershipId}`)}
            />
            {!hideNewAffiliation && (
              <ActionButton label={'Nueva afiliación'} action={handleNewAffiliation} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
